import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../Containers/Config/index.js';
import { GET_DASHBOARD_DETAILS, GET_DASHBOARD_DETAILS_SUCCESS, GET_DASHBOARD_DETAILS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';

function* getV2DashboardDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/get-dashboard-data`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_DASHBOARD_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_DASHBOARD_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_DETAILS_ERROR, payload: error });
  }
}

export function* watchV2DashboardDetails() {
  yield takeEvery(GET_DASHBOARD_DETAILS, getV2DashboardDetails);
}

function* v2DashboardDetailsSaga() {
  yield all([fork(watchV2DashboardDetails)]);
}

export default v2DashboardDetailsSaga;
